import { render, staticRenderFns } from "./prerequisite.vue?vue&type=template&id=79a6d058&"
import script from "./prerequisite.vue?vue&type=script&lang=js&"
export * from "./prerequisite.vue?vue&type=script&lang=js&"
import style0 from "./prerequisite.vue?vue&type=style&index=0&id=79a6d058&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a6d058')) {
      api.createRecord('79a6d058', component.options)
    } else {
      api.reload('79a6d058', component.options)
    }
    module.hot.accept("./prerequisite.vue?vue&type=template&id=79a6d058&", function () {
      api.rerender('79a6d058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/greenfilm/prerequisite.vue"
export default component.exports